import * as VideoImageType from 'common/constants/video-image-type';
import Environment from 'common/utils/environment';
import { camelCaseKeys } from 'common/utils/json-utils';
import { computed, extendObservable, toJS } from 'mobx';
import { find } from 'lodash';
import { parseTimestamp } from 'common/utils/datetime-utils';


class Video {
    constructor(props) {
        extendObservable(this, camelCaseKeys(props));
    }

    destroy() {}

    toJS() {
        return toJS(this);
    }

    /*=======================================
    =            Computed Values            =
    =======================================*/

    @computed get adContext() {
        if (window.AS_FW_CONTEXT) {
            return window.AS_FW_CONTEXT;
        } else if (this.cvpContext) {
            return this.cvpContext;
        } else if (this.auth) {
            return 'authenticated';
        } else {
            const device = Environment.mobile ? (Environment.ios ? 'ios' : Environment.android ? 'android' : 'other') : 'desktop';
            return `unauthenticated-${device}`;
        }
    }

    @computed get durationFormatted() {
        return parseTimestamp(this.duration);
    }

    @computed get expired() {
        return (this.expirationDate && parseInt(Date.now() * 0.001, 10) > this.expirationDate);
    }

    @computed get thumbnail() {
        if (!this.images || this.images.length < 1) return null;
        const main = find(this.images, { name: VideoImageType.MAIN });
        const legacy = find(this.images, { name: VideoImageType.LEGACY });
        return (main && main.url) ? main.url : (legacy && legacy.url) ? legacy.url : null;
    }
}


export default Video;



// WEBPACK FOOTER //
// ./src/common/models/video.js